export const snakeToCamelCase = (value?: string): string => value?.toLowerCase().replace(
  /(_\w)/g,
  key => key[1].toUpperCase(),
);